import type { ReactNode } from 'react';

import { styled } from '/imports/ui/foundation/Theme';

interface Props {
  intro?: ReactNode;
  question?: ReactNode;
  feedback?: ReactNode;
}

export const SolveQuizGrid = ({ intro, question, feedback }: Props) => (
  <Container>
    <ContentGrid>
      {intro != null && <Intro>{intro}</Intro>}
      {question != null && <Question>{question}</Question>}
      {feedback != null && <Feedback>{feedback}</Feedback>}
    </ContentGrid>
  </Container>
);

const Container = styled('div', () => ({
  containerType: 'inline-size',
}));

const LEFT_COL_MAX_WIDTH = 600;
const RIGHT_COL_MIN_WIDTH = 240;

const ContentGrid = styled('div', ({ tokens }) => ({
  display: 'grid',
  gap: tokens.sizeLG,

  gridTemplateColumns: `minmax(0, ${LEFT_COL_MAX_WIDTH}px) minmax(${RIGHT_COL_MIN_WIDTH}px, 1fr)`,
  gridTemplateAreas: `"intro ."
                      "question feedback"`,

  [`@container (max-width: ${LEFT_COL_MAX_WIDTH + RIGHT_COL_MIN_WIDTH + tokens.sizeLG}px)`]: {
    gridTemplateColumns: `minmax(0, ${LEFT_COL_MAX_WIDTH}px)`,
    gridTemplateAreas: `"intro"
                        "question"
                        "feedback"`,
  },
}));

const Intro = styled('div', () => ({
  gridArea: 'intro',
}));

const Question = styled('div', () => ({
  gridArea: 'question',
}));

const Feedback = styled('div', () => ({
  gridArea: 'feedback',
}));
